import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import React from "react";
import { SHOPIFY_URL } from "../../utils/shopify.utils";
import ContainedButton from "../../components/Buttons/ContainedButton";
import whyEvrbedSlide2 from "../../assets/images/whyEvrbedSlide2-2.png";

import { Button } from "@mui/material";

import { StyledDivWithRadius } from "./WhyEvrbed.styles";
import ShopNowButton from "./ShopNowButton";

// const WhyEvrbedSlide2 = () => {
//   const { t } = useTranslation();
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   let navigate = useNavigate();
//
//   return (
//     <div className="col-3 ">
//       <img
//         style={{ width: "1450px", height: "830px", marginTop: "-70px" }}
//         src={whyEvrbedSlide2}
//       ></img>
//       <div
//         className="row"
//         style={{
//           width: "1450px",
//           height: "830px",
//           marginTop: "-900px",
//           position: "relative",
//           top: 0,
//           left: 0,
//           background: "transparent",
//         }}
//       >
//         <div
//           className="col-2"
//           style={{ marginTop: "360px", marginLeft: "400px" }}
//         >
//           <ContainedButton
//             className="col-auto"
//             onClick={() => navigate("/mattress-builder")}
//           >
//             {t("BUILD MY BED")}
//           </ContainedButton>
//         </div>
//         <div style={{ paddingTop: "310px", marginLeft: "1150px", position:"relative", zIndex:1000 }}>
//           <ContainedButton
//             className="col-auto"
//             onClick={() => {
//               return (window.location.href = SHOPIFY_URL + "collections/all");
//             }}
//           >
//             {t("SHOP COMPONENTS")}
//           </ContainedButton>
//         </div>
//         <div>
//           <ShopNowButton
//             styles={{ marginTop: "-320px", marginLeft: "210px" }}
//           ></ShopNowButton>
//           <ShopNowButton
//             styles={{ paddingTop: "205px", marginLeft: "570px" }}
//           ></ShopNowButton>
//           <ShopNowButton
//             styles={{ paddingTop: "40px", marginLeft: "480px" }}
//           ></ShopNowButton>
//           <ShopNowButton
//             styles={{ paddingTop: "0px", marginLeft: "180px" }}
//           ></ShopNowButton>
//         </div>
//       </div>
//     </div>
//   );
// };

import {
  BlueFilledLeafMedium,
  FactorySamples,
  GreenFilledLeafExtraSmall,
  GreenRegularLeaf,
  SquareOfSquaresLarge,
} from "./WhyEvrbed.images";

import styled from "styled-components";

import Mattress from "./Mattress";

const SlideContainer = styled(StyledDivWithRadius)`
  flex-direction: column;
  width: 1500px;
  margin-right: 40px;
`;

const PositionedBlueFilledLeafMedium = styled(BlueFilledLeafMedium)`
  margin-left: 1174px;
  margin-top: -164px;
`;

const ModularAndReplaceable = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  let navigate = useNavigate();
  const onClickBuildMyBed = () =>
    (window.top.location.href = SHOPIFY_URL + "pages/mattress-builder");

  return (
    <SlideContainer
      backgroundColor={"#eff5f9"}
      // opacity={0.06}
    >
      <TopHalfContainer theme={theme}>
        <SquareOfSquaresLarge />
        <ContentContainer>
          <Title theme={theme}>{t("Modular and Replaceable")}</Title>
          <Subtitle theme={theme}>{t("A Mattress Industry First")}</Subtitle>
          <Paragraph theme={theme}>
            {t("The only mattress on the market with replaceable components.")}
          </Paragraph>
          <GreenButton
            onClick={onClickBuildMyBed}
            t={t}
            text={"BUILD MY BED"}
            size={{
              height: "53px",
              width: "169px",
            }}
          />
        </ContentContainer>
        <ImageContainer>
          <GreenRegularLeaf />
          <GreenFilledLeafExtraSmall />
        </ImageContainer>
      </TopHalfContainer>
      <BottomHalfContainer>
        <Mattress />
        <SampleContainer>
          <FactorySamples />
          <PositionedBlueFilledLeafMedium />
          <PositionedTitle>{"It's all in the zippers!"}</PositionedTitle>
          <PositionedText>
            Replace the Cooling Cover and Internal components as needed!
          </PositionedText>
          <GreenButton
            t={t}
            onClick={() => {
              return (window.top.location.href = SHOPIFY_URL + "collections/all");
            }}
            text={"SHOP COMPONENTS"}
            size={{ height: "53px" }}
            margin={"0 0 0 1248px;"}
          />
        </SampleContainer>
      </BottomHalfContainer>
    </SlideContainer>
  );
};

const SampleContainer = styled.div`
  position: relative;
`;

const GreenButton = ({ onClick, t, text, margin, size }) => (
  <ContainedButton
    className="col-auto"
    onClick={onClick}
    styles={{
      ...size,
      margin,
    }}
  >
    {t(text)}
  </ContainedButton>
);

const TopHalfContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const BottomHalfContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const ContentContainer = styled.div`
  flex-direction: column;
`;

const Title = styled.h1`
  font-size: 50px;
  padding-top: 10px;
  color: ${props => props.theme.COLORS.BLUE.darkBlueGreen};
  font-family: Noto Sans, sans-serif;
`;

const Subtitle = styled.h2`
  font-size: 38px;
  padding-top: 4px;
  color: ${props => props.theme.COLORS.BLUE.darkBlueGreen};
  font-family: Noto Sans, sans-serif;
`;

const Paragraph = styled.p`
  font-size: 24px;
  padding-top: 4px;
  max-width: 436px;
  color: ${props => props.theme.COLORS.BLUE.darkBlueGreen};
  font-family: Noto Sans, sans-serif;
`;

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const PositionedTitle = styled.p`
  font-size: 25px;
  font-family: Noto Sans, sans-serif;
  font-weight: bold;
  margin-left: 1229px;
  margin-top: -215px;
  width: 165px;
  color: white;
  text-align: center;
`;

const PositionedText = styled.p`
  font-size: 16px;
  font-family: Noto Sans, sans-serif;
  margin-left: 1201px;
  margin-top: 21px;
  width: 218px;
  text-align: center;
  color: white;
`;

export default ModularAndReplaceable;
